import {Command} from "./Command";
import {GamePlay} from "../model/game-play";
import {FirstDownCommand} from "./FirstDownCommand";
import {ODK} from "../model/odk";

/**
 * S'assurer de faire un 1st down si distance <= 0
 */
export class SafeFirstDownCommand implements Command {
  private commands: Command[] = [];

  constructor(
    private gamePlay: GamePlay
  ) { }

  execute() {
    console.log('COMMAND SafeFirstDownCommand')

    // Dans le cas d'un next kick, on n'augmente pas le down/distance // TODO à valider quand ce n'est pas une pénalité
    if (this.gamePlay.odk === ODK.Kick) return

    if (this.gamePlay.distance == null) {
      console.warn('this.gamePlay.distance est undefined')
      return
    }

    if (this.gamePlay.distance <= 0) {
      this.commands.push(
        new FirstDownCommand(this.gamePlay))

      console.group('Executer sous commandes')
      for (const command of this.commands) {
        command.execute();
      }
      console.groupEnd()
    }
  }
}
